export default __webpack_public_path__ + "static/media/client5.640713b1.png";